<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Organic Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first">
            <sub-product tit="Organic Line" file="organic">
                유기농 코튼, BCI코튼, 리싸이클 폴리에스터, 대나무 섬유, 옥수수 섬유(소로나), 에코베로 등. 환경 문제가 대두됨에 따라 원단 시장 또한 변화하고 있습니다. 메이텍스는 환경 인증된 공장들과 협력하며 다양한 친환경 소재를 다루고 있습니다.
            </sub-product>
        </sub-section>

        <sub-section class="page-section--last">
            <v-container>
                <v-row class="py-30 py-md-60 px-30" style="border: 1px solid #e6e6e6">
                    <v-card style="margin: 0 auto;" flat>
                        <v-img src="/images/sub/product/organic/main_img.png" style="max-width: 600px;"></v-img>
                    </v-card>
                </v-row>
            </v-container>
            <!-- <v-img src="/images/sub/product/organic/organic-img2.jpg"></v-img> -->
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped></style>
